// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2UPhj","productName":"Table_productName__1HeQX"};